import React from "react";
import { cn } from "@/lib/utils";

export default function KpiCard({
  label,
  value,
  hint,
  icon: Icon,
  accent = "default", // default | success | warning | danger | gold
  className,
  testId,
}) {
  const accentMap = {
    default: "text-gray-900",
    success: "text-emerald-700",
    warning: "text-amber-700",
    danger: "text-[#9B1C1C]",
    gold: "text-amber-600",
  };
  const iconBg = {
    default: "bg-gray-100 text-gray-700",
    success: "bg-emerald-50 text-emerald-700",
    warning: "bg-amber-50 text-amber-700",
    danger: "bg-red-50 text-[#9B1C1C]",
    gold: "bg-amber-50 text-amber-700",
  };
  return (
    <div className={cn("kpi-card", className)} data-testid={testId}>
      <div className="flex items-start justify-between">
        <p className="text-xs font-semibold uppercase tracking-widest text-gray-500">{label}</p>
        {Icon && (
          <div className={cn("h-8 w-8 rounded-md flex items-center justify-center", iconBg[accent])}>
            <Icon className="h-4 w-4" strokeWidth={1.75} />
          </div>
        )}
      </div>
      <p className={cn("font-heading text-3xl font-bold tracking-tight mt-2", accentMap[accent])}>
        {value}
      </p>
      {hint && <p className="text-xs text-gray-500 mt-1">{hint}</p>}
    </div>
  );
}
